import { useEffect, useState, React } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "../../styles/Legend.css";
import { RAIN_LEGEND_VALUE } from "../../utils/Constants.tsx";

const WeatherLegend = () => {
  const map = useMap();
  const [legendContent, setLegendContent] = useState(null);

  useEffect(() => {
    const legend = L.control({ position: "bottomright" });

    legend.onAdd = () => {
      const div = L.DomUtil.create("div", "info legend");
      setLegendContent(div);
      return div;
    };

    legend.addTo(map);
    return () => {
      legend.remove();
    };
  }, [map]);

  return (
    legendContent && (
      <div className="leaflet-bottom leaflet-right leaflet-legend mb-4">
        <div className="info legend">
          {RAIN_LEGEND_VALUE.map((item) => (
            <div className="legend-content mt-1">
              <div
                className="weather-legend"
                style={{ backgroundColor: item.color }}
              ></div>
              <span className="weather-legend-text">{item.range}</span>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default WeatherLegend;
